/**
 * Portal Manta · aluciAuditarTexto
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { NORMAS_ABNT_NBR } from '../../data/normas-abnt-nbr.js';
import { LEIS_FEDERAIS_BR } from '../../data/leis-federais-br.js';
import { ALUCI_PADROES, SICRO_REGISTRY, SICRO_COBERTURA_AVISO } from '../../app-globals.js';

function aluciAuditarTexto(texto, opcoes){
  opcoes = opcoes || {};
  const online = !!opcoes.online; // sem efeito offline; flag mantida p/ compatibilidade
  const achados = [];
  const contadores = {'AL-01_abnt':0,'AL-01_lei':0,'AL-02_url':0,'AL-02_doi':0,'AL-03_sicro':0};

  const linha = (idx) => texto.slice(0, idx).split('\n').length;

  for (const p of ALUCI_PADROES){
    const re = new RegExp(p.regex.source, p.regex.flags);
    let m;
    while ((m = re.exec(texto)) !== null){
      contadores[p.tipo] += 1;
      const trecho = m[0];
      const ln = linha(m.index);

      if (p.tipo === 'AL-01_abnt'){
        const cod = m[1];
        if (!NORMAS_ABNT_NBR[cod]){
          achados.push({tipo:p.tipo, severidade:'alta', trecho, linha:ln, status:'NÃO LOCALIZADA',
            cod, ano:m[2]||null,
            acao:'norma ABNT NBR '+cod+' não consta no registry; verificar ou substituir por norma vigente'});
        }
      }
      else if (p.tipo === 'AL-01_lei'){
        const num = m[1], ano = m[2];
        const key = num + '_' + ano;
        if (!LEIS_FEDERAIS_BR[key]){
          achados.push({tipo:p.tipo, severidade:'alta', trecho, linha:ln, status:'NÃO LOCALIZADA',
            cod: num+'/'+ano,
            acao:'Lei '+num+'/'+ano+' não consta no registry federal (pode ser estadual/municipal — verifique)'});
        }
      }
      else if (p.tipo === 'AL-02_url'){
        const url = trecho.replace(/[.,;:)\]]+$/, '');
        const motivos = [];
        if (/localhost|127\.0\.0\.1/.test(url)) motivos.push('localhost (URL de dev)');
        if (!/\.[a-z]{2,}(\/|$|\?|#)/i.test(url)) motivos.push('sem TLD válido');
        if (motivos.length){
          achados.push({tipo:p.tipo, severidade:'media', trecho:url, linha:ln, status:'SUSPEITA (estrutural)',
            acao:'URL suspeita: '+motivos.join(', ')+'; testar manualmente'});
        }
      }
      else if (p.tipo === 'AL-02_doi'){
        achados.push({tipo:p.tipo, severidade:'baixa', trecho, linha:ln, status:'NÃO VERIFICADO (offline)',
          acao:'DOI estruturalmente OK; resolução requer rede (CrossRef)'});
      }
      else if (p.tipo === 'AL-03_sicro'){
        const cod = m[1];
        if (!SICRO_REGISTRY[cod]){
          achados.push({tipo:p.tipo, severidade:'alta', trecho, linha:ln, status:'CÓDIGO INEXISTENTE NO REGISTRY',
            cod,
            acao:'buscar código equivalente via skill sicro-similaridade ou validar com SICRO oficial DNIT (registry é amostra)'});
        }
      }
    }
  }

  const total = Object.values(contadores).reduce((s,n)=>s+n, 0);
  const nAlta  = achados.filter(a=>a.severidade==='alta').length;
  const nMedia = achados.filter(a=>a.severidade==='media').length;
  const nBaixa = achados.filter(a=>a.severidade==='baixa').length;

  let confidence, msg;
  if (total === 0){
    confidence = 1.0;
    msg = 'Nenhum padrão validável encontrado. Auditoria Pacote A não se aplica a este texto.';
  } else {
    const ratio = achados.length / Math.max(total, 1);
    confidence = Math.max(0.0, 1.0 - 0.7*ratio);
    msg = achados.length+' achado(s) de '+total+' padrão(ões) detectado(s)';
  }

  return {
    skill:'aluci-guard', version:'0.1.0', pacote:'A · Referência factual',
    confidence: Math.round(confidence*100)/100, msg,
    sumario:{
      padroes_detectados_total: total,
      padroes_por_tipo: contadores,
      achados_total: achados.length,
      severidade_alta: nAlta, severidade_media: nMedia, severidade_baixa: nBaixa,
    },
    achados,
    modo: online ? 'online' : 'offline',
    cobertura_registry:{
      normas_abnt: Object.keys(NORMAS_ABNT_NBR).length,
      leis_federais: Object.keys(LEIS_FEDERAIS_BR).length,
      sicro_codigos: Object.keys(SICRO_REGISTRY).length,
      sicro_aviso: SICRO_COBERTURA_AVISO,
    },
    timestamp: new Date().toISOString(),
  };
}

export { aluciAuditarTexto };
export default aluciAuditarTexto;
